import React from "react";
import "../../styles/ComponentsStyles/Universal/ToggleButton.style.css";

const ToggleButton = ({ onToggle, isActive = false }) => {
  const handleToggle = () => {
    if (onToggle) onToggle(!isActive); // parent handles toggling
  };

  return (
    <div
      className={`toggle-switch ${isActive ? "on" : "off"}`}
      onClick={handleToggle}
    >
      <div className="toggle-thumb" />
    </div>
  );
};

export default ToggleButton;
